import React from "react";

const Header = () => {
  return <h1 style={{ textAlign: "center" }}>Expense Tracker</h1>;
};
export default Header;
